const carddata = [{
"id": 0,
"image": require("../images/svg/beer-solid.svg"),
"title": "More than 8 out of 10",
"firstcopy": "12-18 year-olds in Maine",
"italics": "do not",
"endcopy": "drink alcohol"
},
{
"id": 1,
"image": require("../images/svg/cannabis-solid.svg"),
"title": "More than 8 out of 10",
"firstcopy": "12-18 year-olds in Maine",
"italics": "do not",
"endcopy": "use marijuana"
},
{
"id": 2,
"image": require("../images/svg/pills-solid.svg"),
"title": "More than 9 out of 10",
"firstcopy": "12-18 year-olds",
"italics": "do not",
"endcopy": "misuse pain relievers"
},
{
"id": 3,
"image": require("../images/svg/smoking-solid.svg"),
"title": "More than 9 out of 10",
"firstcopy": "12-18 year-olds in Maine",
"italics": "do not",
"endcopy": "use tobacco"
},
{
"id": 4,
"image": require("../images/svg/pack-solid.svg"),
"title": "8 OUT OF 10",
"firstcopy": "12-18 year-olds in Maine",
"italics": "have never",
"endcopy": "tried a cigarette"
},
{
"id": 5,
"image": require("../images/svg/vape.svg"),
"title": "Almost 7 out of 10",
"firstcopy": "12-18 year-olds in Maine",
"italics": "have never",
"endcopy": "vaped"
}];

export default carddata;



// WEBPACK FOOTER //
// ./src/data/gridcards.js